module.exports = __webpack_public_path__ + "static/img/2021.1325344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2021.png
// module id = BgoP
// module chunks = 0